import { useMemo } from 'react'
import { getContract } from 'wagmi/actions'

import { useProviderOrSigner } from './useProviderOrSigner'
import { getRouterProcessorContractConfig } from './useSushiSwapRouter'
import { AMM_ENABLED_NETWORKS } from './useTrade'

/**
 * @param {number | undefined}chainId
 * @return {Contract | null}
 */
export function useRouters(chainId: number | undefined) {
  const walletClient = useProviderOrSigner()
  return useMemo(() => {
    if (chainId && walletClient && AMM_ENABLED_NETWORKS.includes(chainId)) {
      return getContract({
        ...getRouterProcessorContractConfig(chainId),
        walletClient: walletClient ? walletClient : undefined,
      })
    } else return undefined
  }, [chainId, walletClient])
}
